<template>

    <div>
<!--        <div v-if="true" style="text-align: center; padding: 30px">-->
<!--            功能暂停，维护中，维护时间预计30分钟-->
<!--        </div>-->

        <div>
            <!--        <div class="top_tools_div">-->
            <van-sticky :offset-top="offsetTop">
                <div style="background-color: white; box-shadow: 0 2px 3px #cccccc;">

                    <PddCategoryTabs ref="PddCategoryTabs" v-if="pdd_pid" @onSelect="selectCategory"></PddCategoryTabs>

                    <div v-if="allParams.keyword || allParams.optid !== -2" id="checkbox_sort_div"
                         :class="checkbox_sort_div">
                        <van-divider
                                :style="{borderColor: '#cccccc', 'margin-top': '0px', 'margin-bottom': '0px'}"></van-divider>

                        <!-- 优惠券 -->
                        <van-checkbox-group v-model="check_result" @change="onCheckBoxChange">
                            <van-row style="margin-left: 15px; margin-top: 10px; margin-bottom: 10px">
                                <van-col span="12">
                                    <van-checkbox :name="check_list[0]" shape="round" checked-color="#ff0000">
                                        {{check_list[0]}}
                                    </van-checkbox>
                                </van-col>
                                <van-col span="12">
                                    <van-checkbox :name="check_list[1]" shape="round" checked-color="#ff0000">
                                        {{check_list[1]}}
                                    </van-checkbox>
                                </van-col>
                                <!--                                <van-col span="8">-->
                                <!--                                    <van-checkbox :name="check_list[2]" shape="round" checked-color="#ff0000">-->
                                <!--                                        {{check_list[2]}}-->
                                <!--                                    </van-checkbox>-->
                                <!--                                </van-col>-->
                            </van-row>
                        </van-checkbox-group>

                        <van-divider
                                :style="{borderColor: '#cccccc', 'margin-top': '0px', 'margin-bottom': '0px'}"></van-divider>
                        <!-- 排序 -->
                        <div v-if="$common.getPid()">
                            <PddSortTabs ref="jdSortTabs" @onSelect="onSortSelect"></PddSortTabs>
                            <!--                        <van-row v-if="!$common.isClient_whole()">-->
                            <!--                            <van-col span="20">-->
                            <!--                                &lt;!&ndash; 排序 &ndash;&gt;-->
                            <!--                                <PddSortTabs ref="jdSortTabs" @onSelect="onSortSelect"></PddSortTabs>-->
                            <!--                            </van-col>-->
                            <!--                            <van-col span="4">-->
                            <!--                                <Wp_options_filter_model @getFilterData="getFilterData"></Wp_options_filter_model>-->
                            <!--                            </van-col>-->
                            <!--                        </van-row>-->
                        </div>

                    </div>
                </div>
            </van-sticky>


            <!--        <div :style="{position: 'relative', top: allParams.keyword || allParams.optid !== optid_for_top ? '195px' : '110px'}">-->
            <div style="margin-top: 10px">
                <div style="text-align: center; margin-bottom: 10px">
                    <!--                <van-button type="danger" @click="getPinduoduoPid_pdd">测试——获取pid</van-button>-->
                    <!--                <van-button type="danger" @click="deletePinduoduoPid">测试——删除pid</van-button>-->
                    <!--                <van-button type="danger" @click="getSkuDetail">获取商品详情</van-button>-->
                </div>

                <div>
                    <!--                <div style="margin-left: 15px; font-size: 12px; color: red">-->
                    <!--                    *预估佣金与实际佣金可能不同，请以订单中的佣金为准<br/>-->
                    <!--                </div>-->

                </div>

                <Wp_pull_list v-if="pdd_pid" ref="Wp_pull_list" :all-params="allParams"
                         :top-params-pdd="topParams"
                         :page-size="pageSize"
                         :use-function="true"
                         @getDatas="getDatas"
                         @onLoad="onLoad"
                >
                    <div v-if="$common_pdd.getPddPid() && $store.state.username && $store.state.username !== 'guest'">
                        <PddSkuInfoCard
                                v-for="(sku_info, index) in sku_list"
                                v-bind:key="index"
                                :skuInfo="sku_info"
                        >
                        </PddSkuInfoCard>
                    </div>
                    <div v-else>

                        <van-grid :column-num="2" :border="false">
                            <van-grid-item
                                    v-for="(sku_info, index) in sku_list"
                                    :key="index"
                            >
                                <div slot="default" style="box-shadow: 1px 1px 5px #999999; border-radius: 10px">
                                    <PddSkuInfoCard_No_Pid
                                            v-bind:key="index"
                                            :skuInfo="sku_info"
                                            orientation="vertical"
                                    ></PddSkuInfoCard_No_Pid>
                                </div>

                            </van-grid-item>
                        </van-grid>
                    </div>
                </Wp_pull_list>
            </div>
        </div>
    </div>
</template>

<script>
    import Wp_pull_list from "../../list/Wp_pull_list";
    import {Toast, Dialog} from "vant";
    import PddSkuInfoCard from "../custom/PddSkuInfoCard";
    import PddSortTabs from "../custom/PddSortTabs";
    import PddCategoryTabs from "../custom/PddCategoryTabs";
    import Wp_options_filter_model from "../../custom/Wp_options_filter_model";
    import PddSkuInfoCard_No_Pid from "../custom/PddSkuInfoCard_No_Pid";

    export default {
        name: "Wp_pdd_select_base",
        components: {
            PddSkuInfoCard_No_Pid,
            Wp_options_filter_model, PddCategoryTabs, PddSortTabs, PddSkuInfoCard, Wp_pull_list
        },
        props: {
            offsetTop: {type: Number, default: 0},
            keywords: {type: String, default: ''},
        },
        data() {
            return {
                //滚动条到顶部的距离的临时存储
                scroll_top_temp: 0,
                //checkbox_sort_div对应的div的class的值
                checkbox_sort_div: "checkbox_sort_div_show",
                //用于判断向下或向上滚动时，只操作一次checkbox_sort_div的值
                scroll_once_temp: true,

                pageSize: 20,
                allParams: {
                    keyword: "",//商品关键词，与opt_id字段选填一个或全部填写
                    optid: -2,//商品标签类目ID
                    page: 1,//默认值1，商品分页数
                    pagesize: 10,//默认100，每页商品数量
                    sorttype: 0,//排序方式:0-综合排序;1-按佣金比率升序;2-按佣金比例降序;3-按价格升序;4-按价格降序;5-按销量升序;6-按销量降序;7-优惠券金额排序升序;8-优惠券金额排序降序;9-券后价升序排序;10-券后价降序排序;11-按照加入多多进宝时间升序;12-按照加入多多进宝时间降序;13-按佣金金额升序排序;14-按佣金金额降序排序;15-店铺描述评分升序;16-店铺描述评分降序;17-店铺物流评分升序;18-店铺物流评分降序;19-店铺服务评分升序;20-店铺服务评分降序;27-描述评分击败同类店铺百分比升序，28-描述评分击败同类店铺百分比降序，29-物流评分击败同类店铺百分比升序，30-物流评分击败同类店铺百分比降序，31-服务评分击败同类店铺百分比升序，32-服务评分击败同类店铺百分比降序
                    withcoupon: true,//是否只返回优惠券的商品，false返回所有商品，true只返回有优惠券的商品
                    rangelist: "",
                    catid: "",//商品类目ID，使用pdd.goods.cats.get接口获取
                    goodsidlist: "",//商品ID列表。例如：[123456,123]，当入参带有goods_id_list字段，将不会以opt_id、 cat_id、keyword维度筛选商品
                    merchanttype: -1,//店铺类型，1-个人，2-企业，3-旗舰店，4-专卖店，5-专营店，6-普通店（未传为全部）
                    pid: this.$common_pdd.getPddPid(),//推广位id
                    customparameters: "",//自定义参数
                    merchanttypelist: "",//店铺类型数组
                    isBrandgoods: false,//是否为品牌商品
                    activitytags: "",//商品活动标记数组，例：[4,7]，4-秒杀 7-百亿补贴等
                    listid: "",//翻页时必填前页返回的list_id值
                },

                topParams: {
                    pid: this.$common_pdd.getPddPid(),
                    page: 0,
                    size: 10,
                    sort: 1,
                    listid: "",
                },

                sku_list: [],

                search_value: '',

                check_list: ['优惠券', '旗舰店'],
                check_result: ['优惠券'],

                //下拉刷新结束
                isLoading: false,

                is_top_goods: true,

                pdd_pid: '',

                optid_for_top: -2,
            }
        },

        watch: {
            keywords(newKeywords) {
                this.search_value = newKeywords;
                this.clickToSearch();
            }
        },

        created() {

            this.allParams.customparameters = this.$store.state.username;

            this.checkAuth(()=>{
                // this.checkSearchAuth();
            });

            if (this.keywords) {
                this.search_value = this.keywords;
                this.allParams.keyword = this.search_value;
                this.allParams.optid = -1;
            }
            //num_iids=606856641695&md5=4b3bd5c3983e435242ff724c2339aa62&rnum=1
            // this.$log("md5 --- " + this.$md5('1584322386173' + 'Waps_jd_MD5key'))
        },
        mounted() {
            document.documentElement.scrollTop = document.body.scrollTop = 0;

            window.addEventListener('scroll', this.scrollListener, true);
        },
        destroyed() {
            window.removeEventListener('scroll', this.scrollListener);
        },

        methods: {

            checkSearchAuth(){
                this.pdd_pid = this.$common_pdd.getPddPid();
                if(this.pdd_pid){
                    let params = {
                        pid: this.pdd_pid,
                        customparameters: this.$store.state.username
                    };
                    this.$checkAuthRecord_pdd(params, response=>{
                        if(response && response.code === 200){
                            if(response.data === 0){//未授权备案

                                if (this.$common.isWx_mini()) {
                                    if(this.$store.state.username !== 'guest') {
                                        this.$common.navigateToMiniProgramPage('/pages/wp_pdd/wp_pdd_search_auth/wp_pdd_search_auth?', 'pdd_pid', this.pdd_pid);
                                    }
                                } else {

                                    this.$getBindAuthRecordData_pdd(params, response => {
                                        if (response && response.code === 200) {
                                            if (response.h5_url) {
                                                Dialog.confirm({
                                                    title: '提示',
                                                    message: '拼多多搜索功能需要拼多多的功能授权，请授权后使用\n若暂不需要使用拼多多搜索功能，可取消'
                                                }).then(() => {
                                                    window.location.href = response.h5_url;
                                                }).catch(()=>{

                                                })

                                            }
                                        }
                                    });
                                }
                            }
                        }
                    })
                }
            },

            getFilterData(filterData) {
                this.initStatus();

                let pricefrom = filterData.price_min;//单位：元
                let priceto = filterData.price_max;
                let commissionShareStart = parseInt(filterData.commission_share_min);//百分比
                let commissionShareEnd = parseInt(filterData.commission_share_max);

                let range_list = [];

                let range_price = {};
                if (pricefrom !== -1) {
                    range_price.range_id = 0;
                    range_price.range_from = pricefrom * 100;//单位：分
                }
                if (priceto !== -1) {
                    range_price.range_id = 0;
                    range_price.range_to = priceto * 100;//单位：分
                }
                if (range_price && typeof (range_price.range_id) !== 'undefined') {
                    range_list.push(range_price);
                }

                let range_commissionShare = {};
                if (commissionShareStart !== -1) {
                    range_commissionShare.range_id = 2;
                    range_commissionShare.range_from = commissionShareStart * 10; //千分比
                }
                if (commissionShareEnd !== -1) {
                    range_commissionShare.range_id = 2;
                    range_commissionShare.range_to = commissionShareEnd * 10; //千分比
                }
                if (range_commissionShare && typeof (range_commissionShare.range_id) !== 'undefined') {
                    range_list.push(range_commissionShare);
                }

                this.allParams.rangelist = range_list;

                this.$refs.Wp_pull_list.onLoad();
            },
            getSkuDetail() {
                let params = this.allParams;
                params.goodsidlist = '12879147968';
                this.$getSelectGoods_pdd(params, response => {
                    this.$log(response)
                    if (response && response.code === 200) {
                        if (response.data && response.data.goods_search_response && response.data.goods_search_response.goods_list) {

                        } else {

                            Toast.fail({
                                message: '请求超时，请下拉刷新' + response.code
                            })
                        }
                    } else {
                    }
                })
            },

            selectCategory(categoryData) {
                this.$log(categoryData)
                this.initStatus();

                if (categoryData.cat_id === -1) {
                    this.allParams.optid = this.optid_for_top;
                } else {
                    this.allParams.optid = -1;
                }
                this.$log("this.allParams.optid = " + this.allParams.optid)
                this.allParams.catid = categoryData.cat_id;

                this.allParams.keyword = '';
                this.search_value = '';

                this.$emit('clearSearch');

                this.$refs.Wp_pull_list.onLoad();
            },

            /**
             * 删除缓存中的taobao_pid（测试使用）
             */
            deletePinduoduoPid() {
                let user = this.$store.state;
                user.pdd_pid = '';
                this.$store.commit('login', user);
                // window.location.reload();
            },

            /**
             * 检查拼多多授权
             */
            checkAuth(fn) {

                this.pdd_pid = this.$common_pdd.getPddPid();
                this.$log("pdd_pid = " + this.pdd_pid);
                if (!this.pdd_pid) {
                    //如果登录信息中的pdd_pid为空，则请求获取生成拼多多pid
                    this.getPinduoduoPid_pdd(pid => {
                        if (!pid) {
                            pid = "9788668_133678743";
                        }
                        if (pid) {
                            this.pdd_pid = pid;

                            this.topParams.pid = pid;

                            //存储到登录信息缓存中
                            let user = this.$store.state;
                            user.pdd_pid = pid;
                            // user.userPhone = "";
                            this.$store.commit('login', user);

                            Toast.success({
                                message: '授权成功\n重新加载...'
                            });
                            if(fn){
                                fn()
                            }

                            // if(this.$config.project === 'mini'){
                            //
                            // }else{
                            //     setTimeout(()=>{
                            //         //重载页面
                            //         window.location.reload();
                            //     }, 600);
                            // }
                        }
                    });
                }else{
                    if(fn){
                        fn()
                    }
                }

            },

            /**
             * 获取拼多多的推广位id
             */
            getPinduoduoPid_pdd(fn) {
                let loadingToast = Toast.loading({
                    message: '授权中...',
                    forbidClick: false,
                    duration: 0,
                });

                let params = {
                    p_id_name_list: this.$store.state.username,
                    number: '1',
                };
                this.$getPinduoduoPid_pdd(params, response => {
                    //data: [{create_time: 1585536501, pid: "9788668_133678743", pid_name: "S101", p_id: "9788668_133678743"}]
                    if (response) {
                        if (response.code === 200) {
                            if (response.data && response.data.length > 0) {
                                loadingToast.clear();
                                fn(response.data[0].p_id)
                            }
                        } else if (response.code === 300) {
                            // msg: "error"
                            // code: 300
                            // data: {error_response: {error_msg: "业务服务错误", sub_msg: "S101已经存在", sub_code: "2", error_code: 50001}}
                            // fn('9788668_133678743');

                            let channel_name = this.$store.state.username;
                            let _pdd_pid = '';
                            this.$getPid(channel_name, res => {
                                if (res && res.code === 200) {
                                    _pdd_pid = res.data.pdd_channel_id;
                                    fn(_pdd_pid)
                                }
                                loadingToast.clear();
                            });
                            if (this.$config.project !== 'mini') {
                                if (!_pdd_pid || _pdd_pid === 'null' || _pdd_pid === 'undefined') {
                                    Dialog.alert({
                                        message: '您当前账号已经完成过授权，请退出重新登录，以保证拼多多相关功能可正常使用！'
                                    });
                                }
                            }

                        } else {
                            loadingToast.clear();
                            Dialog.alert({
                                message: '授权失败，请退出重新登录再进行尝试；\n若仍未成功，请联系客服。'
                            });
                            fn(null)
                        }
                    }
                })
            },

            /**
             * 下拉刷新
             */
            onRefresh() {
                this.initStatus();

                this.$refs.Wp_pull_list.onLoad();
            },

            /**
             * 排序选项被选中
             */
            onSortSelect(label, sort) {
                this.initStatus();
                this.$log("label = " + label)
                //排序方式:0-综合排序;1-按佣金比率升序;2-按佣金比例降序;3-按价格升序;4-按价格降序;
                // 5-按销量升序;6-按销量降序;7-优惠券金额排序升序;8-优惠券金额排序降序;
                // 9-券后价升序排序;10-券后价降序排序;11-按照加入多多进宝时间升序;12-按照加入多多进宝时间降序;
                // 13-按佣金金额升序排序;14-按佣金金额降序排序;15-店铺描述评分升序;16-店铺描述评分降序;
                // 17-店铺物流评分升序;18-店铺物流评分降序;19-店铺服务评分升序;20-店铺服务评分降序;
                // 27-描述评分击败同类店铺百分比升序，28-描述评分击败同类店铺百分比降序，
                // 29-物流评分击败同类店铺百分比升序，30-物流评分击败同类店铺百分比降序，
                // 31-服务评分击败同类店铺百分比升序，32-服务评分击败同类店铺百分比降序
                if (label) {
                    if (label === "price") {
                        // 3-按价格升序;4-按价格降序
                        //9-券后价升序排序;10-券后价降序排序
                        if (sort === 'desc') {
                            this.allParams.sorttype = 10;
                        } else {
                            this.allParams.sorttype = 9;
                        }
                    } else if (label === "promotion_rate") {
                        //1-按佣金比率升序;2-按佣金比例降序
                        if (sort === 'desc') {
                            this.allParams.sorttype = 2;
                        } else {
                            this.allParams.sorttype = 1;
                        }
                    } else if (label === "total_sales") {
                        //5-按销量升序;6-按销量降序;
                        if (sort === 'desc') {
                            this.allParams.sorttype = 6;
                        } else {
                            this.allParams.sorttype = 5;
                        }
                    }

                } else {
                    this.allParams.sorttype = 0;
                }

                this.$refs.Wp_pull_list.onLoad();
            },

            /**
             * 复选框筛选条件改变的回调
             */
            onCheckBoxChange(check_values) {
                if (this.isTopGoodes()) {
                    Toast.fail({
                        message: ''
                    });
                }
                this.initStatus();

                //优惠券
                if (check_values.includes(this.check_list[0])) {
                    this.allParams.withcoupon = true;
                } else {
                    this.allParams.withcoupon = false;
                }
                //旗舰店
                if (check_values.includes(this.check_list[1])) {
                    this.allParams.merchanttype = 3;
                } else {
                    this.allParams.merchanttype = -1;
                }

                this.$refs.Wp_pull_list.onLoad();
            },


            /**
             * 根据条件查询数据
             */
            clickToSearch() {
                // if(this.search_value && this.allParams.keyword && this.search_value !== this.allParams.keyword){
                //
                // }
                this.initStatus();

                this.checkSearchAuth();


                this.allParams.keyword = this.search_value;
                this.allParams.catid = '';
                if (!this.search_value) {
                    this.allParams.optid = this.optid_for_top
                }
                this.$log("this.search_value = " + this.search_value)

                this.$refs.Wp_pull_list.onLoad();
            },

            selectCategrayTab(id) {
                this.$refs.PddCategoryTabs.active_model = id;
                this.$refs.PddCategoryTabs.onSelect(id);
            },

            searchInputClick(id) {
                this.selectCategrayTab(id);
            },

            getSearchValue(value) {
                this.search_value = value;
            },

            initStatus() {
                this.$refs.Wp_pull_list.initStatus();
                this.sku_list = [];
                this.allParams.listid = "";
                this.topParams.listid = "";

                document.documentElement.scrollTop = document.body.scrollTop = 0;
            },


            initAllParams() {
                if (this.allParams) {
                    //默认选中优惠券
                    if (this.check_result.includes(this.check_list[0])) {
                        this.all_params.has_coupon = true;
                    }
                }
            },


            onLoad(data_list) {
                this.sku_list = data_list;

                this.$emit('onLoad')
            },

            isTopGoodes() {
                if (!this.allParams.keyword && this.allParams.optid === this.optid_for_top) {
                    return true;
                } else {
                    return false;
                }
            },

            getDatas(params, fn) {
                if (this.pdd_pid) {
                    // if(this.$common_pdd.getPddPid()) {
                    if (this.isTopGoodes()) {
                        this.$getTopGoods_pdd(params, response => {
                            if (response && response.code === 200) {
                                if (response.data && response.data.goods_basic_detail_response && response.data.goods_basic_detail_response.list) {
                                    this.$log('top list_id = ' + response.data.goods_basic_detail_response.list_id)
                                    this.topParams.listid = response.data.goods_basic_detail_response.list_id;
                                    if (fn) {
                                        fn(response.data.goods_basic_detail_response.list)
                                    }
                                } else {
                                    if (fn) {
                                        fn(null);
                                    }
                                    Toast.fail({
                                        message: '请求超时，请下拉刷新' + response.code
                                    })
                                }
                            } else {
                                if (fn) {
                                    fn(null);
                                }
                            }
                        })
                    } else {
                        this.$getSelectGoods_pdd(params, response => {
                            this.$log(response)
                            if (response && response.code === 200) {
                                if (response.data && response.data.goods_search_response && response.data.goods_search_response.goods_list) {
                                    this.$log('search list_id = ' + response.data.goods_search_response.list_id)
                                    this.allParams.listid = response.data.goods_search_response.list_id;
                                    if (fn) {
                                        fn(response.data.goods_search_response.goods_list)
                                    }
                                } else {
                                    if (fn) {
                                        fn(null);
                                    }
                                    Toast.fail({
                                        message: '请求超时，请下拉刷新' + response.code
                                    })
                                }
                            } else {
                                if (fn) {
                                    fn(null);
                                }
                            }
                        })
                    }
                }
            },

            /**
             * 选品界面中的滚动条的监听
             */
            scrollListener() {
                //滚动条距离顶部距离
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                // this.$log("window.pageYOffset = " + window.pageYOffset)
                // this.$log("document.documentElement.scrollTop = " + document.documentElement.scrollTop)
                // this.$log("document.body.scrollTop = " + document.body.scrollTop)

                if (this.scroll_top_temp <= scrollTop && scrollTop > 80) {
                    //向下滚动时隐藏筛选和排序
                    // checkbox_sort_div.style.display = 'none';

                    if (this.scroll_once_temp) {
                        this.checkbox_sort_div = "checkbox_sort_div_hide";
                        this.scroll_once_temp = false;
                    }

                } else {
                    //向上滚动时显示筛选和排序
                    // checkbox_sort_div.style.display = 'block';

                    if (!this.scroll_once_temp) {
                        this.checkbox_sort_div = "checkbox_sort_div_show";
                        this.scroll_once_temp = true;
                    }
                }

                this.scroll_top_temp = scrollTop;

            },
        }
    }
</script>

<style scoped>
    .top_tools_div {
        width: 100%;
        min-height: 80px;
        position: fixed;
        top: 0px;
        z-index: 1999;
        /*box-shadow: 0px 1px 5px #999*/
    }

    .checkbox_sort_div_hide {
        max-height: 0px;
        -webkit-transition: max-height 0.5s;
        transition: max-height 0.5s;
        overflow: hidden;
    }

    .checkbox_sort_div_show {
        overflow: hidden;
        -webkit-transition: max-height 0.5s;
        transition: max-height 0.5s;
        max-height: 100px;
    }

    /deep/ .van-grid-item .van-grid-item__content {
        background-color: rgba(255, 255, 255, 0);
        padding: 5px;
    }
</style>